import { env } from '@/env';

export const flattenSortOptions = (sortOptions) =>
  sortOptions?.flatMap((item) => {
    const type = item.type ?? undefined;
    const transformedChildren =
      item.children?.map((i) => ({ ...i, type })).sort((a, b) => a.label.localeCompare(b.label)) ??
      [];
    return [item, ...transformedChildren];
  });

export function getNumericOptions() {
  const numericValues = Array.from({ length: 10 }, (_, i) => i + 1);
  const numericValuesEven = numericValues.filter((option) => option === 1 || option % 2 === 0);
  const numericOptions = numericValues.map((value) => ({ value, label: value }));
  const numericOptionsEven = numericValuesEven.map((value) => ({ value, label: value }));
  const rowLimitOptions = [{ value: 'auto', label: 'No Limit' }, ...numericOptions.slice(0, 6)];
  return { numericOptions, numericOptionsEven, rowLimitOptions };
}

export function getGalleryWidgetScript(
  galleryId,
  {
    type = 'gallery',
    rowSize = 4,
    gapSize = 4,
    mobileRowSize = 4,
    mobileGapSize = 2,
    rowLimit = 'auto',
    callToAction = null,
    enableLinks = true,
    displayPrice = true,
    originalResolution = false,
    showScroll = true,
    autoPlay = false,
  } = {},
) {
  const args = [
    `data-gallery-id="${galleryId}"`,
    `data-row-size="${rowSize}"`,
    `data-gap-size="${gapSize}"`,
    `data-mobile-row-size="${mobileRowSize}"`,
    `data-mobile-gap-size="${mobileGapSize}"`,
    rowLimit !== 'auto' ? `data-row-limit="${rowLimit}" data-lazy="true"` : '',
    callToAction ? `data-call-to-action="${callToAction}"` : '',
    enableLinks ? '' : 'data-links-disabled="true"',
    displayPrice ? 'data-show-price="true"' : '',
    originalResolution ? 'data-media-format="original"' : '',
  ];

  let embedUrl = '';
  if (type === 'gallery') {
    embedUrl = env.galleryEmbedUrl;
    args.unshift('data-name="dhboard"');
  } else {
    embedUrl = env.carouselEmbedUrl;
    args.unshift('data-name="dhboard-carousel"');
    args.push(
      autoPlay ? 'data-autoplay="true"' : '',
      showScroll ? '' : 'data-scroll-disabled="true"',
    );
  }

  args.unshift('type="text/javascript"');
  // without the escape \ JS will crash, with the linter still telling you the escape is unnecessary.
  // eslint-disable-next-line
  return `<script src="${embedUrl}" ${args.filter((arg) => arg).join(' ')}><\/script>`;
}
